/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE API STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	loading: {
		textAlign: 'center',
		'& p':{
			padding:pxToEm(25)
		},
		"& img": {
			width: pxToEm(100)
		}
	}
});